import React from 'react';
import { useFormikContext } from 'formik';
import { AcceptRequestFlowValues } from '../../../types/appointments';
import { LoadedUser } from '../../../interfaces';
import { OrganizationBusiness } from '../../../types/organizations';
import {
  getArtistDefaultReply,
  getNextArtistDefaultReply,
} from '../../../utils/form/artistDefaultReply';

type ReplyBusiness = Pick<OrganizationBusiness, 'employeesToBusinesses'> | null;

export function useArtistDefaultReplySync({
  loadedUser,
  business,
}: {
  loadedUser: LoadedUser | null | undefined;
  business: ReplyBusiness;
}) {
  const { values, setFieldValue, initialValues } =
    useFormikContext<AcceptRequestFlowValues>();
  const lastAppliedReplyDefaultRef = React.useRef(
    initialValues.customDesignMessage || '',
  );
  const currentReplyRef = React.useRef(values.customDesignMessage || '');
  const nextDefault = getArtistDefaultReply({
    loadedUser,
    employeeId: values.employeeId,
    business,
  });

  React.useEffect(() => {
    currentReplyRef.current = values.customDesignMessage || '';
  }, [values.customDesignMessage]);

  React.useEffect(() => {
    const decision = getNextArtistDefaultReply({
      currentReply: currentReplyRef.current,
      lastAppliedDefault: lastAppliedReplyDefaultRef.current,
      nextDefault,
    });
    lastAppliedReplyDefaultRef.current = decision.lastAppliedDefault;
    if (decision.shouldApply && decision.value !== currentReplyRef.current) {
      setFieldValue('customDesignMessage', decision.value);
    }
  }, [nextDefault, setFieldValue]);
}
